var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"formula-tooltip"},[_c(_setup.StakeTooltip,{attrs:{"label":_setup.tooltipContent,"position":"top","trigger":"hover","active":!!_setup.props.formula}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }